import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const isGenesysReAuthenticatingState = atom({
  key: 'isGenesysReAuthenticatingState',
  default: false,
});

/**
 * useIsGenesysReAuthenticating
 * During conversation with agent, the token that Genesys uses for authentication might expire (after an hour),
 * in that case, Genesys SDK need to fetch a new token and do the authentication again. This hook gives a flag
 * that shows whether our application is in that re-authenticating process.
 */
export const useIsGenesysReAuthenticating = () => {
  const isGenesysReAuthenticating = useRecoilValue(
    isGenesysReAuthenticatingState,
  );
  const setIsGenesysReAuthenticating = useSetRecoilState(
    isGenesysReAuthenticatingState,
  );

  return { isGenesysReAuthenticating, setIsGenesysReAuthenticating };
};
